/**
 * DJB2 XOR variant — fast non-cryptographic hash returning a stable unsigned 32-bit integer as a string.
 * @see http://www.cse.yorku.ca/~oz/hash.html
 */
export function djb2Hash(s: string): string {
  let h = 5381;
  for (let i = 0; i < s.length; i++) {
    h = ((h << 5) + h) ^ s.charCodeAt(i);
    h |= 0;
  }
  return String(h >>> 0);
}
